import { Link } from 'react-router'
import styled from 'styled-components'

import { UserShortAvatar } from '@root/entities/user-short/ui/user-short-avatar'
import { ProfileRoute } from '@root/features/routing/model'

import type { PairActivity } from '../../model'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  activity: PairActivity.PremiumActivity
} & ClassNameProps

export const PremiumFeedTableUserCell: React.FC<Props> = ({ activity }) => {
  return (
    <Root to={ProfileRoute.build({ delugeId: activity.purchaser.delugeId })}>
      <UserShortAvatar size={18} userShort={activity.purchaser} />
      <Username>{activity.purchaser.username}</Username>
    </Root>
  )
}

const Root = styled(Link)`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 4px;

  color: var(--text-9);
  &:link,
  &:visited {
    color: var(--text-9);
  }
  transition: color 0.15s linear;
  &:hover {
    color: var(--text-11);
  }
`

const Username = styled.div`
  font-size: 11px;
  font-weight: 500;
  line-height: 16px;

  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  white-space: nowrap;
`
